import type { ConversationView } from '@hilo/contracts';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { fetchInboxPage, keys, pollInterval } from '../../lib/queries';
import { apiFilters, useInboxFilters } from './useInboxFilters';

/** La bandeja con los filtros de la URL. Varios componentes la leen; TanStack comparte la misma consulta. */
export function useInboxList() {
  const { filters } = useInboxFilters();
  const query = apiFilters(filters);
  const list = useInfiniteQuery({
    queryKey: keys.inboxList(query),
    queryFn: ({ pageParam }) => fetchInboxPage(query, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (page) => page.nextCursor,
    refetchInterval: pollInterval,
  });

  // La paginación es una vista cambiante: una conversación puede repetirse entre páginas.
  const items = useMemo(() => {
    const seen = new Map<string, ConversationView>();
    for (const page of list.data?.pages ?? []) for (const item of page.items) if (!seen.has(item.id)) seen.set(item.id, item);
    return [...seen.values()];
  }, [list.data]);

  return { list, items, filters };
}
